import { FlaskConical, Monitor, Languages, BookMarked, Globe2, Palette } from 'lucide-react';

export const LAB_META = {
  ipa: { title: 'Lab IPA', icon: FlaskConical, guruLabel: 'Guru IPA' },
  komputer: { title: 'Lab Komputer', icon: Monitor, guruLabel: 'Guru TIK' },
  bahasa: { title: 'Lab Bahasa', icon: Languages, guruLabel: 'Guru Bahasa' },
  agama: { title: 'Lab Agama', icon: BookMarked, guruLabel: 'Guru Agama' },
  ips: { title: 'Lab IPS', icon: Globe2, guruLabel: 'Guru IPS' },
  seni: { title: 'Lab Seni', icon: Palette, guruLabel: 'Guru Seni' },
};

export default LAB_META;
